import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const UOM2 = ({ value, onChange, placeholder = "Select Unit", className = "control-Select mb-3", disabled }) => {
    return (
        <Select
            disabled={disabled}
            className={className}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            allowClear
        >
            <Option value="BAG">BAG</Option>
            <Option value="PACKET">PACKET</Option>
            <Option value="BOTTLE">BOTTLE</Option>
        </Select>
    );
};

export default UOM2;
